import { render, staticRenderFns } from "./WithEnvelope.vue?vue&type=template&id=7400ff58&scoped=true"
import script from "./WithEnvelope.vue?vue&type=script&lang=js"
export * from "./WithEnvelope.vue?vue&type=script&lang=js"
import style0 from "./WithEnvelope.vue?vue&type=style&index=0&id=7400ff58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7400ff58",
  null
  
)

export default component.exports